import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as l, normalizeClass as d, createElementVNode as s } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconHash",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ s("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.055 1.003a.5.5 0 0 1 .442.552L5.225 4H7.22l.284-2.555a.5.5 0 1 1 .994.11L8.225 4H10a.5.5 0 0 1 0 1H8.114l-.222 2H10a.5.5 0 0 1 0 1H7.78l-.283 2.555a.5.5 0 0 1-.994-.11L6.775 8H4.78l-.284 2.555a.5.5 0 0 1-.994-.11L3.775 8H2a.5.5 0 1 1 0-1h1.886l.222-2H2a.5.5 0 1 1 0-1h2.22l.283-2.555a.5.5 0 0 1 .552-.442ZM5.115 5l-.223 2h1.994l.222-2H5.114Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  _
];
function m(e, u, i, f, p, a) {
  return l(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--hash"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Hash",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, h, 10, c);
}
const v = /* @__PURE__ */ n(o, [["render", m]]);
export {
  v as default
};
//# sourceMappingURL=hash.js.map
